module.exports = __webpack_public_path__ + "img/tablog.f8a54e0d.png";